import { useHasPermission } from "@dexteel/mesf-core";
import { Navigate } from "react-router-dom";
import { CraftsPage } from "./CraftsPage";

export const CRAFTS_PERMISSION = "MMS.UpsertCraft";

const Crafts = () => {
	const hasPermissionTo = useHasPermission();

	if (!hasPermissionTo(CRAFTS_PERMISSION)) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <CraftsPage />;
};

export default Crafts;
